var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fancybox" }, [
    _c(
      "div",
      { staticClass: "image-wrapper" },
      [
        _c("div", { staticClass: "header" }, [
          _vm.index > -1
            ? _c("div", { staticClass: "entry-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.entryId) + " ")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "play",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.play($event)
                }
              }
            },
            [
              !_vm.isPlay
                ? _c("icon", { attrs: { type: "play", color: "#ccc" } })
                : _c("icon", { attrs: { type: "pause", color: "#ccc" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "full",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.full($event)
                }
              }
            },
            [
              !_vm.isFullScreen
                ? _c("icon", { attrs: { type: "full", color: "#ccc" } })
                : _c("icon", { attrs: { type: "exitfull", color: "#ccc" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showclosebutton,
                  expression: "showclosebutton"
                }
              ],
              staticClass: "close",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.close($event)
                }
              }
            },
            [_c("icon", { attrs: { type: "close", color: "#ccc" } })],
            1
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.images, function(item) {
          return _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: item.index === _vm.index + 1,
                expression: "item.index===index+1"
              }
            ],
            ref: "images",
            refInFor: true,
            staticClass: "image animated lazyload",
            attrs: { "data-src": item.imageUrl },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.addIndex($event)
              }
            }
          })
        }),
        _vm._v(" "),
        _vm.index > -1
          ? _c("div", { staticClass: "footer" }, [
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showcaption,
                    expression: "showcaption"
                  }
                ],
                staticClass: "caption",
                domProps: { innerHTML: _vm._s(_vm.images[_vm.index].caption) },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showimagecount,
                      expression: "showimagecount"
                    }
                  ],
                  staticClass: "count",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.index + 1) +
                      " " +
                      _vm._s(_vm.imagecountseparator) +
                      " " +
                      _vm._s(_vm.images[_vm.index].total)
                  )
                ]
              )
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.index > 0
      ? _c(
          "div",
          {
            staticClass: "arrow left",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.decIndex($event)
              }
            }
          },
          [_c("icon", { attrs: { type: "arrowLeft", color: "#ccc" } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.index > -1 && _vm.index < _vm.images[_vm.index].total - 1
      ? _c(
          "div",
          {
            staticClass: "arrow right",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.addIndex($event)
              }
            }
          },
          [_c("icon", { attrs: { type: "arrowRight", color: "#ccc" } })],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }